module.exports = __webpack_public_path__ + "static/skyscrapers-8e45c443113cf3911c34a40bd3dba3b0.jpg";